import React from "react";
import { PASS_MARK } from "../utils/constants";

export function StatusPill({ status, accuracy }) {
  if (status === "Pass") {
    return (
      <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-700">
        Pass {accuracy != null ? `(${accuracy}%)` : ""}
      </span>
    );
  }
  if (status === "Fail") {
    return (
      <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-700">
        Fail {accuracy != null ? `(${accuracy}%)` : ""}
      </span>
    );
  }
  return (
    <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold bg-slate-100 text-slate-600">
      Unanswered
    </span>
  );
}
